// FILE: src/pages/info/InfoPage.jsx
// Frame for information pages that exist both before sign-in (public site)
// and inside the student area: the same content, in the right shell.
import React from "react";
import PublicLayout from "../../layouts/PublicLayout";
import { PageHeader } from "../../components/ui";

export default function InfoPage({ variant = "public", title, description, breadcrumbs, actions, children }) {
  const header = <PageHeader title={title} description={description} breadcrumbs={breadcrumbs} actions={actions} />;
  if (variant === "student") {
    return (
      <>
        {header}
        {children}
      </>
    );
  }
  return (
    <PublicLayout wide>
      {header}
      {children}
    </PublicLayout>
  );
}
